import { useEffect } from 'react'
import {
  ViewContainer,
  FlexContainer,
  Header,
  clearError,
  ErrorBoundary,
  getParameterByName,
} from 'j-comps'
import Body from './Body'
import { resetState, setMemberId, setSource } from '../../data/actions'
import { connect } from 'react-redux'
import SettingsDropdown from './SettingsDropdown'
import CanvaDropdown from './CanvaDropdown'
import config from '../../config'
import { store } from '../..'
import { Helmet } from 'react-helmet'

const Stream = ({ designs, source, errorMessage }) => {
  useEffect(() => {
    resetState()
    const source = getParameterByName({ store, name: 'source' })
    setSource(source)
    const memberId = getParameterByName({ store, name: 'uid' })
    setMemberId(memberId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleErrorClose = () => {
    clearError({ store })
  }

  return (
    <ViewContainer
      appName={config.app}
      type={source}
      noBoxShadow={process.env.NODE_ENV === 'production'}
    >
      <Helmet>
        <title>
          {config.vendor.name.titleCase}
          {source ? ` - ${source}` : ''}
        </title>
      </Helmet>
      <Header
        appName={config.app}
        genericItems={
          designs && designs.length ? (
            <CanvaDropdown linkText={'Create and Edit via Content Sources'} />
          ) : null
        }
        settingsButton={<SettingsDropdown />}
      />
      <FlexContainer>
        <ErrorBoundary errorMessage={errorMessage} onClick={handleErrorClose}>
          <Body />
        </ErrorBoundary>
      </FlexContainer>
    </ViewContainer>
  )
}

const mapStateToProps = (state) => ({
  designs: state.designs,
  source: state.source,
  errorMessage: state.errorMessage,
})

export default connect(mapStateToProps)(Stream)
